"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const organizationTranslation = {
    selectOrganization: "Select an Organization",
    noOrgAssigned: "Your account is not registered with an organization.",
    contactTo: "For support, contact ",
    expired: "Expired",
    expiringSoon: "Expiring Soon",
    menuButton: {
        profile: "Profile",
        refresh: "Refresh",
        settings: "Settings",
    },
    headerMenu: {
        newInternalGroup: "New Internal Group",
        newPatientGroup: "New Patient Group",
        newBroadcast: "New Broadcast",
        organizationMedia: "Organization Media",
        newMessage: "New Message",
        newChatGroup: "New Chat Group",
        createBroadcast: "Create Broadcast",
    },
};
exports.default = organizationTranslation;
